<p class="text-muted text-{{ pAlign }} {{ pMoreClasses }}">
    <i class="fa fa-spinner fa-spin"></i> {{ 'SHARED.LOADING' | translate }}
</p>
